<template>
  <div class="alert-message-container">
    <app-list-transition>
      <app-message
        :key="msg.id"
        v-for="(msg) in messages"
        :level="msg.level"
        :title="msg.title"
        :content="msg.content"
        class="alert-message elevation-10"
        @close="remove(msg)" />
    </app-list-transition>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import {mapState} from 'vuex';

export default {
  methods: {
    ...mapActions('alert', ['add', 'remove'])
  },

  computed: {
    ...mapState({
      messages: state => state.alert.messages
    })
  }
};
</script>

<style lang="stylus" scoped>

.alert-message-container {
  position: fixed;
  width: 40vw;
  z-index: 999;
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
}

.alert-message {
  width: 100%;
  margin-bottom: 1rem;
}

.alert-animate--enter, .alert-animate--leave-active {
  // since scoped style may not be replaced, use !important to force change style.
  opacity: 0 !important;
}

.alert-animate--enter-active , .alert-animate--leave-active {
  // since scoped style may not be replaced, use !important to force change style.
  transition: 1s;
}

.alert-animate--enter-active {
  animation-name: slidedown;
  animation-duration: 1s;
}

.alert-animate--leave-active {
  animation-name: slideup;
  animation-duration: 1s;

  position: absolute !important;
  // since the container does not define specific width, when the position of item change to absolute,
  // the width of item will change as small as it can, that's why need to define 'width: 100%'
  // to make item to keep it's original width.
  width: 100%;
}

// this style will be applied to all items which position need to be changed.
.alert-animate--move {
  transition: all 1s;
}

@keyframes slidedown {
  0% {
    transform: translateY(-50%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideup {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-50%);
    opacity: 0;
  }
}


@media (max-width: $extra-small-width) {
  .alert-message-container {
    right: 0;
    top: 0;
    min-width: 100%;
  }

  .alert-message {
    margin-bottom: 0.4rem;
    border-radius: 0 !important;
    width: 100%;
  }
}
</style>
